import { createRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useMe } from '../auth';
import { rootRoute } from './root';

// Bare-bones index. Sends signed-in users to /cases, anonymous users to /login.
// In M5 this becomes a real splash, but for the M1 shell it's just routing.

export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: IndexRoute,
});

function IndexRoute() {
  const me = useMe();
  const navigate = useNavigate();

  useEffect(() => {
    if (me.isLoading) return;
    if (me.data?.user) {
      navigate({ to: '/cases', replace: true });
    } else {
      navigate({ to: '/login', replace: true });
    }
  }, [me.isLoading, me.data, navigate]);

  return <p className="centered muted">Loading…</p>;
}
